module.exports = __webpack_public_path__ + "img/gold.b0c3a43b.png";